export function hasRequestAdvertisingZoneName(
    advertisingZoneName?: string | null,
): boolean {
    return Boolean(advertisingZoneName?.trim());
}

export function getRequestLocationName(params: {
    advertisingZoneName?: string | null;
    storeName?: string | null;
}): string {
    const zoneName = params.advertisingZoneName?.trim();
    if (zoneName) {
        return zoneName;
    }

    return params.storeName?.trim() || 'N/A';
}
